import React from "react";
import { SocialIcon } from "react-social-icons";
import photo from '../assets/me.jpg';
import mastodon from "../utils/mastodon_logo";

class Home extends React.Component {

    render() {
        return (
            <div className="App">
                <nav>
                    <a href="/projects">projects</a>
                </nav>
                <header className="App-header">
                    <img src={photo} className="App-logo" alt="logo" />
                    <h1>Liam Edwards</h1>
                    <p>
                        "Swiss Army Knife" Software Developer.
                        <br/>
                        But my favourite is a mobile focus, using:
                        <br/>
                        <span className="code">Jetpack Compose</span>
                        <span className="code">SwiftUI</span>
                        <span className="code">Flutter</span>
                    </p>
                    <div className="social">
                        <SocialIcon
                            target="_blank"
                            rel="noopener noreferrer me"
                            url="https://mastodon.nz/@blowonthepi"
                            defaultSVG={mastodon} />

                        <SocialIcon
                            target="_blank"
                            rel="noopener noreferrer"
                            url="https://linkedin.com/in/imliamedwards" />

                        <SocialIcon
                            target="_blank"
                            rel="noopener noreferrer"
                            url="https://github.com/blowonthepi"
                            fgColor="white"
                            bgColor="black" />

                        <SocialIcon
                            target="_blank"
                            rel="noopener noreferrer"
                            url="mailto:kiaora@liam.kiwi" />
                    </div>
                </header>
            </div>
        );
    }
}

export default Home